// extracted by mini-css-extract-plugin
export default {"container":"Advantages_container__aCWnp","advantages":"Advantages_advantages__+Bgq5","title":"Advantages_title__M8S76","content":"Advantages_content__2O7Rg"};